import React from "react";
import { playSound } from "../utils/soundUtils.js";

// Available notification sounds
const notificationSounds = [
  { filename: "Peter.aiff", displayName: "Peter" },
  { filename: "Classic.aiff", displayName: "Classic" },
  { filename: "Crisp Alert.aiff", displayName: "Crisp Alert" },
  { filename: "Crystal.aiff", displayName: "Crystal" },
  { filename: "Gentle Ping.aiff", displayName: "Gentle Ping" },
  { filename: "Signature.aiff", displayName: "Signature" },
  { filename: "Sunny Chime.aiff", displayName: "Sunny Chime" },
  { filename: "Beepboop.aiff", displayName: "Beepboop"},
  { filename: "Descend.aiff", displayName: "Descend"},
  { filename: "Scifi.aiff", displayName: "Scifi"},
];

function SoundSelector({ 
  selectedSound, 
  onSoundChange, 
  defaultSound = "Classic.aiff",
  showTitle = true,
  showDescription = true,
  description = "Select a notification tone to hear how it sounds.",
  className = "",
  title = "Notification Tone"
}) {
  // Handle sound selection change
  const handleSoundChange = (filename) => {
    onSoundChange(filename);
    playSound(filename);
  };

  return (
    <div className={`p-4 bg-slate-50 dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 ${className}`}>
      {showTitle && (
        <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-3">
          {title}
        </h3>
      )}
      <div className="flex items-center space-x-4">
        <select
          value={selectedSound || defaultSound}
          onChange={(e) => handleSoundChange(e.target.value)}
          className="form-select flex-1 max-w-xs"
        >
          {notificationSounds.map((sound) => (
            <option key={sound.filename} value={sound.filename}>
              {sound.displayName}
            </option>
          ))}
        </select>
      </div>
      {showDescription && (
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-2">
          {description}
        </p>
      )}
    </div>
  );
}

export default SoundSelector;
